class waveLandingAds implements ng.IComponentController {
}

angular.module('animatronApp.wave.landingAds', []).component('waveLandingAds', {
    controller: waveLandingAds,
    templateUrl: require('wave/wave-landing-ads.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/wave/waveLandingAds.ts